// Persists scroll position across form submissions so clicking buttons on a
// long page (day view, etc.) doesn't yank the user back to the top.
//
// On any Turbo form submission we stash window.scrollY in sessionStorage,
// then restore it on the next turbo:load and immediately clear the key so
// subsequent loads (link nav, fresh visits) behave normally.

window.addEventListener("turbo:submit-start", () => {
  sessionStorage.setItem("ssf-scroll-restore", String(window.scrollY));
});

window.addEventListener("turbo:load", () => {
  const raw = sessionStorage.getItem("ssf-scroll-restore");
  if (raw === null) return;
  sessionStorage.removeItem("ssf-scroll-restore");
  const y = parseInt(raw, 10);
  if (!Number.isNaN(y)) window.scrollTo(0, y);
});
